import { isEmpty } from 'lodash'
import React, { useMemo } from 'react'
import { SignalAssessmentsViewList } from 'scenes/Dashboard/components/SignalAssessmentsViewList'
import { getOrganizationSignalAssessments } from 'scenes/Dashboard/data/organizations/helpers'
import { Organization } from 'scenes/Dashboard/data/organizations/types'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

export type DealCardSignalAssessmentListProps = {
  organization: Organization
}

export const DealCardSignalAssessmentList = React.memo(({ organization }: DealCardSignalAssessmentListProps) => {
  const { classes } = useStyles()
  const signalAssessments = useMemo(() => getOrganizationSignalAssessments(organization), [organization])
  if (isEmpty(signalAssessments)) {
    return null
  }
  return (
    <>
      <Typography variant="body2" className={classes.header}>
        Signals
      </Typography>
      <SignalAssessmentsViewList displayableField="summary" signalAssessments={signalAssessments} />
    </>
  )
})

DealCardSignalAssessmentList.displayName = 'DealCardSignalAssessmentList'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  header: {
    fontWeight: 'bold',
    marginTop: spacing(2),
  },
}))
